
<template>
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3335 2.91699H5.66683C3.41167 2.91699 1.5835 4.74516 1.5835 7.00033C1.5835 9.25549 3.41167 11.0837 5.66683 11.0837H10.3335C12.5887 11.0837 14.4168 9.25549 14.4168 7.00033C14.4168 4.74516 12.5887 2.91699 10.3335 2.91699Z"
      stroke="#F7F8FD"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.66683 8.75033C6.63333 8.75033 7.41683 7.96682 7.41683 7.00033C7.41683 6.03383 6.63333 5.25033 5.66683 5.25033C4.70033 5.25033 3.91683 6.03383 3.91683 7.00033C3.91683 7.96682 4.70033 8.75033 5.66683 8.75033Z"
      stroke="#F7F8FD"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>